import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { class: "fv-plugins-message-container" }
const _hoisted_16 = { class: "fv-help-block" }
const _hoisted_17 = { class: "row mb-6" }
const _hoisted_18 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_19 = { class: "col-lg-8 fv-row" }
const _hoisted_20 = { class: "fv-plugins-message-container" }
const _hoisted_21 = { class: "fv-help-block" }
const _hoisted_22 = { class: "row mb-6 mt-10" }
const _hoisted_23 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_24 = {
  class: "col-lg-8 fv-row border rounded p-4",
  style: {"background":"#f5f5f5","min-height":"200px"},
  dir: "rtl"
}
const _hoisted_25 = ["innerHTML"]
const _hoisted_26 = { class: "row mb-6" }
const _hoisted_27 = { class: "col-lg-4 col-form-label fw-bold fs-6" }
const _hoisted_28 = { class: "col-lg-8 fv-row" }
const _hoisted_29 = { class: "row mb-6" }
const _hoisted_30 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_31 = { class: "col-lg-8 fv-row" }
const _hoisted_32 = {
  value: "",
  disabled: ""
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("option", { value: "CCE" }, "CCE", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "IVE" }, "IVE", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "IRE" }, "IRE", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "IRE-INVESTMENT" }, "IRE-INVESTMENT", -1)
const _hoisted_37 = { class: "fv-plugins-message-container" }
const _hoisted_38 = { class: "fv-help-block" }
const _hoisted_39 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_40 = {
  key: 0,
  type: "submit",
  id: "kt_account_profile_details_submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_41 = { class: "indicator-label" }
const _hoisted_42 = { class: "indicator-progress" }
const _hoisted_43 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_MonacoEditor = _resolveComponent("MonacoEditor")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('read', 'newsletter'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('updateNewsletterSection')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitUpdate,
            "validation-schema": _ctx.newslettersSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('title')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "title",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('title'),
                      modelValue: _ctx.newsletter.title,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newsletter.title) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "title" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('key')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      type: "text",
                      name: "key",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('key'),
                      modelValue: _ctx.newsletter.key,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newsletter.key) = $event))
                    }, null, 8, ["placeholder", "modelValue"]),
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_ErrorMessage, { name: "key" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", _hoisted_18, _toDisplayString(_ctx.translate('htmlContent')), 1),
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_MonacoEditor, {
                      language: "json",
                      theme: "vs-dark",
                      class: "w-100",
                      style: {"height":"400px"},
                      value: _ctx.newsletter.htmlContent,
                      "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newsletter.htmlContent) = $event))
                    }, null, 8, ["value"]),
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createVNode(_component_ErrorMessage, { name: "htmlContent" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_22, [
                  _createElementVNode("label", _hoisted_23, _toDisplayString(_ctx.translate('htmlPreview')), 1),
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", { innerHTML: _ctx.htmlContentPreview }, null, 8, _hoisted_25)
                  ])
                ]),
                _createElementVNode("div", _hoisted_26, [
                  _createElementVNode("label", _hoisted_27, _toDisplayString(_ctx.translate('sort')), 1),
                  _createElementVNode("div", _hoisted_28, [
                    _createVNode(_component_Field, {
                      name: "sort",
                      autocomplete: "off",
                      class: "form-control form-control-lg form-control-solid",
                      modelValue: _ctx.newsletter.sort,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newsletter.sort) = $event))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.translate('valuationType')), 1),
                  _createElementVNode("div", _hoisted_31, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "valuationType",
                      class: "form-select form-select-lg form-select-solid",
                      modelValue: _ctx.newsletter.variables.valuationType,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newsletter.variables.valuationType) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_32, _toDisplayString(_ctx.translate('selectOption')), 1),
                        _hoisted_33,
                        _hoisted_34,
                        _hoisted_35,
                        _hoisted_36
                      ]),
                      _: 1
                    }, 8, ["modelValue"]),
                    _createElementVNode("div", _hoisted_37, [
                      _createElementVNode("div", _hoisted_38, [
                        _createVNode(_component_ErrorMessage, { name: "valuationType" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                (_ctx.can('update', 'newsletter'))
                  ? (_openBlock(), _createElementBlock("button", _hoisted_40, [
                      _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.translate('saveChanges')), 1),
                      _createElementVNode("span", _hoisted_42, [
                        _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                        _hoisted_43
                      ])
                    ], 512))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}